<div class="sidebar">
  <!-- Navigation Menu -->
  <nav class="sidebar-nav">
    <ul class="nav-list">
      @if(userService.permissions.control ){
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/operational-map"
          routerLinkActive="active"
          placement="right"
          container="body"
          ngbTooltip="Mapa de operativo"
        >
          <i class="bi bi-map"></i>
        </a>
      </li>
      } @if(userService.permissions.stores ||userService.permissions.sectors
      ||userService.permissions.routes || userService.permissions.logistics){
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/operation-controls/stores"
          placement="right"
          ngbTooltip="Control de operaciones"
          [class.active]="isOperationControlsActive()"
        >
          <i class="bi bi-shop"></i>
        </a>
      </li>

      } @if(userService.permissions.users){

      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/users"
          routerLinkActive="active"
          placement="right"
          ngbTooltip="Usuarios"
        >
          <i class="bi bi-people"></i>
        </a>
      </li>
      } @if(userService.permissions.sales){

      <li class="nav-item">
        <a
          class="nav-link"
          href="#"
          placement="right"
          routerLink="/admin/sales/day"
          [class.active]="isSalesActive()"
          ngbTooltip="Ventas"
        >
          <i class="bi bi-coin"></i>
        </a>
      </li>
      } @if(userService.permissions.settings){
      <li class="nav-item">
        <a
          class="nav-link"
          href="#"
          placement="right"
          routerLink="/admin/config"
          routerLinkActive="active"
          ngbTooltip="Configuración"
        >
          <i class="bi bi-gear"></i>
        </a>
      </li>
      } @if(userService.permissions.inventory){
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/inventory"
          routerLinkActive="active"
          placement="right"
          [disableTooltip]="isMobile"
          tooltipClass="sidebar-tooltip-nowrap"
          ngbTooltip="Control de articulos"
        >
          <i class="bi bi-box-seam"></i>
        </a>
      </li>
      } @if(userService.permissions.suggested_calculator){
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/suggested"
          routerLinkActive="active"
          placement="right"
          ngbTooltip="Sugeridos"
        >
          <i class="bi bi-lightbulb"></i>
        </a>
      </li>
      } @if(!userService.isSupervisor){
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/historical-data"
          routerLinkActive="active"
          placement="right"
          ngbTooltip="Datos históricos"
        >
          <i class="bi bi-hdd-rack"></i>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          routerLink="/admin/sales-analytics"
          routerLinkActive="active"
          placement="right"
          ngbTooltip="Análisis de datos"
        >
          <i class="bi bi-pie-chart"></i>
        </a>
      </li>
      }
    </ul>
  </nav>

  <div class="sidebar-footer"></div>
</div>
